<div class="toolbar-container">
  <app-select-search
    floatLabel="never"
    bindValue="id"
    bindLabel="friendlyName"
    [items]="channels"
    [ctrl]="channelsControl"
    placeholder="Channels"
  >
  </app-select-search>

  <app-select-search
    floatLabel="never"
    bindValue="id"
    bindLabel="name"
    [items]="toList | call: rentals"
    [ctrl]="rentalsControl"
    placeholder="Rentals"
  >
  </app-select-search>

  <div class="btn-clear-filters" matTooltip="Clear all filters" (click)="clearFilters()">
    <i class="fal fa-minus-circle"></i>
  </div>

  <div class="spacer"></div>

  <button type="button" class="btn btn-success text-uppercase" (click)="onAdd()" [disabled]="1 | isReadonlyRole">
    <i class="far fa-box-up"></i> Add Channel Adjustment
  </button>
</div>
<div class="table-holder table-responsive">
  <table class="table table-default table-striped">
    <mat-table #table matSort matSortActive="channelName" matSortDirection="asc" [dataSource]="dataSource">
      <ng-container matColumnDef="channelName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Channel Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ getChannelName | call: element.channelId }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="adjustAmount">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Adjust Amount</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.adjustAmount || '' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="adjustPercent">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Adjust Percent</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.adjustPercent ? element.adjustPercent + '%' : '' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="rentals">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Rentals</mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          [matTooltip]="getRentalsTooltip | call: element.rentalIds"
          matTooltipPosition="above"
          matTooltipClass="text-center"
        >
          {{ element.rentalIds.length }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef>Edit</mat-header-cell>

        <mat-cell *matCellDef="let element">
          <div dropdown placement="bottom right" container="body" [isDisabled]="1 | isReadonlyRole">
            <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
              <a class="btn-ellips">
                <i class="fas fa-ellipsis-v"></i>
              </a>
            </div>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
              <li>
                <button (click)="onEdit(element)" type="button"><i class="fal fa-edit"></i>Edit</button>
              </li>
              <li>
                <button (click)="onDelete(element)" type="button"><i class="fal fa-trash-alt"></i>Delete</button>
              </li>
            </ul>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" (click)="onEdit(row)" class="clickable"></mat-row>
    </mat-table>

    <mat-paginator
      #paginator
      [length]="dataSource?.data?.length"
      [class.hidden]="isEmptyTable$ | async"
      [pageSize]="20"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator>

    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType" class="bg-white"></app-empty-table>
  </table>
</div>
